import "../styles/blog.css";
import iitd from '../media/iitd.jpeg';
import covid from '../media/covid.avif';
import ai from '../media/ai.jpg';
import React, { useState } from "react";
const Blog = () => {
  const [expandedPostIndex, setExpandedPostIndex] = useState(null);

  const posts = [
    
    {
      img: covid,
      title: "The Impact of COVID-19 on Indian Education",
      date: "November 04th, 2021",
      publisher: "Rishabh Kumar",
      content: "The COVID-19 pandemic has brought unprecedented challenges to every aspect of life, including education. In India, the impact of the pandemic on education has been significant, with schools and universities closing their doors to students and shifting to online learning in an effort to maintain social distancing and slow the spread of the virus. In this blog post, we will explore the impact of COVID-19 on Indian education, including the challenges faced by students, educators, and policymakers, and the potential long-term implications for the future of education in India.",
      insides: [
        {
          subtitle: "The Challenges Faced by Students and Educators",
          subcontent: [
            {
              element: "One of the most significant challenges faced by students and educators in India has been the sudden shift to online learning. While online learning has its benefits, such as flexibility and accessibility, it has also highlighted the digital divide in India, with many students lacking the necessary devices and internet connectivity to participate in online classes. This has led to a loss of learning opportunities for many students, particularly those from disadvantaged backgrounds. In addition, online learning has also raised concerns about the quality of education being provided, as many teachers were not trained to deliver online classes and may lack the necessary technological infrastructure to do so effectively. This has led to concerns about students falling behind academically, which could have long-term implications for their future prospects.",
            },
          ],
        },
        {
          subtitle: "The Impact on Policymakers",
          subcontent: [
            {
              element: "The COVID-19 pandemic has also had a significant impact on policymakers in India, who have been forced to grapple with the challenge of providing quality education to students while maintaining social distancing and preventing the spread of the virus. This has led to a shift towards blended learning models, which combine online and offline learning to provide a more flexible and resilient education system. However, the shift towards blended learning has also highlighted the need for greater investment in digital infrastructure and teacher training to ensure that students are receiving high-quality education regardless of their location or socioeconomic status. This will require significant investment from both the government and the private sector to bridge the digital divide and provide equal opportunities for all students.",
            },
          ],
        },
        {
          subtitle: "The Long-Term Implications",
          subcontent: [
            {
              element: "The COVID-19 pandemic has highlighted the need for greater resilience and adaptability in the Indian education system, as well as the importance of investing in digital infrastructure and teacher training to ensure that students have access to high-quality education regardless of their location or socioeconomic status. It has also highlighted the importance of developing more flexible and adaptable models of education that can respond to unexpected challenges, such as pandemics or natural disasters. Overall, while the COVID-19 pandemic has presented significant challenges to the Indian education system, it has also provided an opportunity to rethink and restructure education in a way that is more equitable, accessible, and resilient. By investing in digital infrastructure, teacher training, and flexible learning models, India can build a more resilient education system that can provide quality education to all students, regardless of their circumstances.",
            },
          ],
        },
      ],
    },
    {
      img: iitd,
      title: "IIT Delhi",
      date: "July 17th, 2022",
      publisher: "Rishabh Kumar",
      content: "The Indian Institute of Technology (IIT) Delhi is one of the premier engineering institutes in India. Established in 1961, the institute has a rich legacy of producing some of the best minds in the field of engineering and technology. However, like any other institution, IIT Delhi has its fair share of pros and cons that need to be considered before enrolling.",
      insides: [
        {
          subtitle: "Pros",
          subcontent: [
            {
              element: "1. Excellent academic reputation: IIT Delhi is consistently ranked among the top engineering colleges in India and Asia. The institute has an excellent faculty that is well-versed in their respective fields and offers a rigorous curriculum that prepares students for the real world.",
            },
            {
              element: "2. High-quality infrastructure: IIT Delhi has state-of-the-art infrastructure that includes well-equipped labs, modern classrooms, and a vast library. The institute also has top-notch sports facilities and a range of extracurricular activities to promote holistic development.",
            },
            {
              element: "3. Placements: One of the significant advantages of studying at IIT Delhi is its placement record. The institute has a robust placement cell that connects students with some of the best companies in India and abroad. The average salary package offered to students is also quite high.",
            },
            {
              element: "4. Research opportunities: IIT Delhi offers ample opportunities for research and innovation. The institute has various research centers and labs that provide students with the necessary resources to pursue cutting-edge research in their respective fields.",
            },
          ],
        },
        {
          subtitle: "Cons",
          subcontent: [
            {
              element: "1. Highly competitive: As one of the most sought-after engineering colleges in India, IIT Delhi attracts a highly competitive pool of applicants. The selection process is rigorous, and only a few students make the cut.",
            },
            {
              element: "2. Heavy workload: The curriculum at IIT Delhi is intense and demanding, which can be overwhelming for some students. The workload is often heavy, and students may find it challenging to maintain a balance between academics and extracurricular activities.",
            },
            {
              element: "3. Cost of living: The cost of living in Delhi, where IIT Delhi is located, is relatively high compared to other parts of India. Students may find it difficult to manage their finances, especially if they come from lower-income backgrounds.",
            },
            {
              element: "4. Lack of diversity: IIT Delhi has a relatively homogenous student population, with most students coming from an engineering or science background. The lack of diversity may limit students' exposure to different perspectives and ideas.",
            },
          ],
        },
        {
          subtitle: "Conclusion",
          subcontent: [
            {
              element: "IIT Delhi is an excellent choice for students who are looking for a rigorous academic curriculum and top-notch infrastructure. The institute offers ample opportunities for research and innovation and has a robust placement record. However, the highly competitive selection process, heavy workload, high cost of living, and lack of diversity may be a disadvantage for some students. As with any educational institution, it is essential to weigh the pros and cons carefully before making a decision.",
            },
          ],
        },
      ],
    },
    {
      img: ai,
      title: "The Role of Artificial Intelligence in Education",
      date: "December 28th, 2022",
      publisher: "Rishabh Kumar",
      content: "Artificial Intelligence (AI) is an emerging field that has the potential to revolutionize many aspects of our lives, including education. AI has the ability to analyze vast amounts of data, identify patterns and make predictions. In education, AI can be used to enhance teaching and learning, improve student outcomes, and streamline administrative tasks. In this blog, we will discuss the role of artificial intelligence in education.",
      insides: [
        {
          subtitle: "Personalized Learning",
          subcontent: [
            {
              element: "One of the most significant benefits of AI in education is the ability to personalize learning for individual students. AI-powered learning platforms can analyze student data, including performance and behavior, and use this information to provide personalized learning experiences. For example, an AI-powered platform can identify a student's weaknesses in a particular subject and provide targeted resources to help the student improve in that area. This approach can help students learn at their own pace, with tailored resources that match their learning needs and styles."
            },
          ],
        },
        {
          subtitle: "Intelligent Tutoring Systems",
          subcontent: [
            {
              element: "AI can also be used to create intelligent tutoring systems that can provide personalized support to students. These systems can offer instant feedback, answer questions, and adapt to the student's learning style. Intelligent tutoring systems can be particularly helpful for students who need extra help in specific subjects or for students who have learning disabilities.",
            }],
        },
        {
          subtitle: "Automated Grading",
          subcontent: [
            {
              element: "AI-powered grading systems can help teachers save time and reduce the workload associated with grading assignments. Automated grading systems can analyze essays, identify grammatical errors, and provide feedback to students. This approach can help teachers grade more efficiently and provide students with timely feedback to improve their writing skills.",
            },
          ],
        },
        {
          subtitle: "Administrative Tasks",
          subcontent: [
            {
              element: "AI can also be used to streamline administrative tasks in education. For example, AI-powered chatbots can answer student inquiries, provide support, and direct students to appropriate resources. This approach can help schools and universities save time and resources, while providing students with quick and accurate support.",
            },
          ],
        },
        {
          subtitle: "Challenges",
          subcontent: [
            {
              element: "While there are many potential benefits to using AI in education, there are also challenges that need to be addressed. One concern is the potential for AI to reinforce existing biases and inequalities. For example, if an AI-powered platform only provides resources that match a student's learning style, it may not challenge the student to learn in new ways. Additionally, AI-powered grading systems may not be able to recognize the nuances of student writing and could unfairly penalize students who have unique writing styles.",
            },
          ],
        },
        {
          subtitle: "Conclusion",
          subcontent: [
            {
              element: "Artificial intelligence has the potential to revolutionize education by providing personalized learning experiences, intelligent tutoring systems, and automated grading. While there are challenges that need to be addressed, AI can help students learn more efficiently and effectively, while providing teachers with more time to focus on teaching. As AI technology continues to evolve, we can expect to see more innovative approaches to education that leverage the power of AI.",
            },
          ],
        },
      ],
    },
  ];

  const handlePostClick = (index) => {
    if (expandedPostIndex === index) {
      setExpandedPostIndex(null);
    } else {
      setExpandedPostIndex(index);
    }
  };

  return (
    <div className="container">
      <h1 style={{ textAlign: "center" }} >My Blogs</h1>
      {posts.map((post, index) => (
        <div key={index} onClick={() => handlePostClick(index)} style={{ cursor: "pointer" }} className={expandedPostIndex === index ? (
          "blog-col"
        ) : (
          "blog-row"
        )}>
          <img src={post.img} alt="" className="blog-img" />
          <div className="content">
            <h2>{post.title}</h2>
            <p className="date">{post.date} By {post.publisher}</p>
            {expandedPostIndex === index ? (
              <>
                <p>{post.content}</p>
                {post.insides.map((inside) => (
                  <>
                    <h3>{inside.subtitle}</h3>
                    {inside.subcontent.map((element) => (
                      <p>{element.element}</p>
                    ))}
                  </>
                ))}
              </>
            ) : (
              <p>{post.content.substring(0, 500)}<span style={{color: "white"}}>.....Read More</span></p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Blog;
